<template>
  <v-menu
    open-on-hover
    open-delay="150"
    right
    :disabled="disabled"
    offset-x
    nudge-right="12"
  >
    <template #activator="{ attrs, on }">
      <slot name="activator" v-bind="{ attrs, on }"></slot>
    </template>
    <v-card color="#6779A5" dark class="pa-3"><slot></slot></v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'NavTooltip',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
